import React, { Component } from "react";
import NavBar from "../../_components/common/Navbar";
import SingleRater from "./SingleRater";
import MultiRater from "./MultiRater";
import data from "./data.json";
import { connect } from 'react-redux';
import { getAssessementsListAction } from "../../_actions";
import { dashBoardAction } from '../../_actions/dashBoard/dashBoardActions'
import { CommonBreadCrumb } from "../../_components/common/CommonBreadCrumb";
import { LoaderComp } from '../../_components/common/LoaderComp/Loadercomp';
import Page404 from '../404page';

class Assessments extends Component {
    constructor(props) {
        super(props);

        this.state = {
            type: "continous",
            pathId: 0,
            currentDashboardObj: {},
            breadCrumbData: [],
            mainLoader: true,

            hasProperId: true,
            idLoader: true
        };
    }
    componentDidMount() {

        const { dispatch, } = this.props;

        let token = localStorage.getItem('access_token')

        dispatch(dashBoardAction.dashBoardAction1(token))

        let reportIdFromPath = this.props.location.pathname.match(/\d/g);



        this.setState({ pathId: reportIdFromPath.join("") }, () => {
            let breadCrumbData = [
                {
                    link: '/app/dashboard',
                    name: 'DASHBOARD'
                }, {
                    link: '',
                    name: 'QUESTIONNAIRE'
                }
            ]


            if (this.props.location.state) {
                if (this.props.location.state.detail !== undefined) {
                    if (this.props.location.state.detail === 'Invitation') {
                        breadCrumbData = [
                            {
                                link: '/app/dashboard',
                                name: 'DASHBOARD'
                            }, {
                                link: '',
                                name: 'QUESTIONNAIRE'
                            }
                        ]
                    }
                }
            }
            this.setState({
                breadCrumbData
            })
        })

    }

    questionEventDispatcher(data) {

        const { dispatch } = this.props;

        let token = localStorage.getItem('access_token')

        dispatch(dashBoardAction.dashBoardAction1(token))


    }

    componentDidUpdate(prevProps) {
        if (prevProps.dashBoardData !== this.props.dashBoardData) {
            let matchedObj = {}
            if (this.props.dashBoardData !== undefined) {
                this.props.dashBoardData.my_inivation.map(val => {
                    if (val.user_assessment__id == this.state.pathId) {
                        matchedObj = val
                    }
                })
                if (Object.keys(matchedObj).length === 0) {
                    this.props.dashBoardData.user_assessments.map(val => {
                        if (val.id == this.state.pathId) {
                            matchedObj = val
                        }
                    })
                }
                let hasId = true;
                if (Object.keys(matchedObj).length === 0) {
                    hasId = false
                }
                this.setState({
                    hasProperId: hasId,
                    idLoader: false
                })

                this.setState({
                    currentDashboardObj: matchedObj
                }, () => {
                    const { dispatch } = this.props;
                    let data = {}

                    if (this.state.currentDashboardObj.participant__id !== undefined) {
                        data = {
                            instrument_id: `${this.state.currentDashboardObj.instrument__id}`,
                            is_participant: true,
                            user_id: this.state.currentDashboardObj.participant__id,
                            assessment_id: this.state.currentDashboardObj.id
                        }
                    } else {
                        data = {
                            instrument_id: `${this.state.currentDashboardObj.user_assessment__instrument__id}`,
                            is_participant: false,
                            user_id: this.state.currentDashboardObj.respondent__id,
                            assessment_id: this.state.currentDashboardObj.user_assessment__id
                        }
                    }

                    dispatch(getAssessementsListAction.getAssessementsHandler(data, () => {
                        this.setState({
                            mainLoader: false
                        })
                    }))
                })
            }
        }
    }

    render() {
        const { getAssessmentLoading, assessmentResponse, assessment_details } = this.props;


        return (
            <div>
                <NavBar />

                {
                    this.state.idLoader ?
                        <div style={{ height: 'calc(100vh - 150px)' }} className="container d-flex justify-content-center">
                            <LoaderComp color={'black'} />
                        </div>
                        :
                        this.state.hasProperId ?
                            <div className="container custom-container mb-5">
                                <div>
                                    <CommonBreadCrumb
                                        data={this.state.breadCrumbData}
                                    />

                                </div>

                                {
                                    (getAssessmentLoading === true || this.state.mainLoader) &&
                                    <p className="text-center">
                                        <i className="fas fa-spinner fa-spin  " ></i>
                                        &nbsp; Loading</p >
                                }
                                {
                                    (getAssessmentLoading === false && this.state.mainLoader === false) &&
                                    assessmentResponse.instument.instrument_type === 1 && (
                                        <SingleRater assessment={assessment_details.user_assessments} id={this.state.pathId} data={assessmentResponse} />
                                    )
                                }
                                {
                                    (getAssessmentLoading === false && this.state.mainLoader === false) &&
                                    assessmentResponse.instument.instrument_type === 0 && (
                                        <div>
                                            <MultiRater
                                                mainData={assessmentResponse}
                                                currentDashboardObj={this.state.currentDashboardObj}
                                                lastAnsweredQuestion={data.lastAnsweredQuestion}
                                                qoestionEvent={this.questionEventDispatcher.bind(this)}

                                                FirstQuestionNumber={assessmentResponse.questions_list[0].question_number}
                                            />
                                        </div>
                                    )
                                }
                            </div>
                            :
                            <Page404 unauthorised={true} />
                }
            </div>
        );
    }
}

function mapStateToProps(state) {

    const { getAssessmentLoading } = state.getAssessmentList;
    const getAssessmentError = state.getAssessmentList.error;

    const assessmentResponse = (!getAssessmentLoading && !getAssessmentError) ? state.getAssessmentList.data.data : [];

    const { dash_board_data_loading, dash_board_data_error } = state.allotUnallotBatch;
    const dashBoardData = (!dash_board_data_loading && !dash_board_data_error) ? state.dashBoardRed.dash_board_data.data : { my_inivation: [], previous_assessment_list: [], user_assessments: [] }

    const dash_board_data_loading_details = state.dashBoardRed.dash_board_data_loading;
    const assessment_details = (!dash_board_data_loading_details) ? state.dashBoardRed.dash_board_data.data : ''


    return {

        dashBoardData,
        assessment_details,
        dash_board_data_loading,
        dash_board_data_error,

        getAssessmentLoading,
        assessmentResponse,
        getAssessmentError,
    };
}
export default connect(mapStateToProps)(Assessments);



// WEBPACK FOOTER //
// ./src/_pages/Assessments/index.jsx